import { Component, Input } from '@angular/core';
import { Router } from "@angular/router";
import { DashboardResponse } from '../../../api/models/dashboardResponse';
import { RouteURLConstants } from '../../../constants/upplm.constants';
import { UpsCommonService } from '../../../services/upplm.common.service';


@Component({
    selector: 'created1',
    template: require('./dashboardCreated1.component.html')
})

export class Created1Component {

    public ham: boolean = false;
    @Input() dataSearch: DashboardResponse;
    @Input() status: any;

    constructor(private router: Router,
        private _commonService: UpsCommonService,    ) { }

    showHam() {
        this.ham = (this.ham) ? false : true;
    }

    searchInformation() {
        // Call API for search Information
    }

    goToPlacardVerification() {
        this.router.navigateByUrl(`${RouteURLConstants.UPPLM_VIEW_PLACARD_VERIFICATION_ROUTE}?loc=${this._commonService.locale}&placardid=${this.dataSearch.placardId}`);
    }
}